import { render, staticRenderFns } from "./AttributesOverview.vue?vue&type=template&id=4589faae&"
import script from "./AttributesOverview.vue?vue&type=script&lang=js&"
export * from "./AttributesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports